export default "__VITE_ASSET__CvdtoZYz__";